/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './option-view.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../app/components/table-component/option-view/option-view.component';
import * as i4 from 'ngx-toastr';
import * as i5 from 'ngx-bootstrap/modal/bs-modal.service';
const styles_OptionViewComponent:any[] = [i0.styles];
export const RenderType_OptionViewComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_OptionViewComponent,data:{}});
function View_OptionViewComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),9,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),6,'div',[['class','form-group m-0']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['\n      '])),(_l()(),i1.ɵeld(4,0,(null as any),(null as any),0,'input',
          [['class','m-0'],['type','checkbox']],[[8,'checked',0]],[[(null as any),
              'change']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('change' === en)) {
              const pd_0:any = ((<any>_co.changedOption(_v.context.index)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i1.ɵeld(6,0,(null as any),(null as any),1,'label',[['class','form-control-label m-0']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(7,(null as any),['\n        ','\n      '])),(_l()(),i1.ɵted(-1,
          (null as any),['\n    '])),(_l()(),i1.ɵted(-1,(null as any),['\n  ']))],
      (null as any),(_ck,_v) => {
        const currVal_0:any = _v.context.$implicit.display;
        _ck(_v,4,0,currVal_0);
        const currVal_1:any = _v.context.$implicit.title;
        _ck(_v,7,0,currVal_1);
      });
}
function View_OptionViewComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),6,'div',[['class',
      'form-group m-0']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),3,'button',[['class','btn btn-primary btn-icon'],['type','button']],
          (null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.addClick()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i1.ɵeld(4,0,(null as any),(null as any),0,'i',[['class','fa fa-plus']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),[' Thêm\n    '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n  ']))],(null as any),(null as any));
}
export function View_OptionViewComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),7,'div',[['class',
      'col-12'],['style','max-height: 60vh; overflow: auto']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
      ['\n  '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_OptionViewComponent_1)),i1.ɵdid(3,802816,(null as any),0,i2.NgForOf,[i1.ViewContainerRef,
      i1.TemplateRef,i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),
      i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
      1,(null as any),View_OptionViewComponent_2)),i1.ɵdid(6,16384,(null as any),0,
      i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (_ck,_v) => {
        var _co:i3.OptionViewComponent = _v.component;
        const currVal_0:any = _co.displayOption;
        _ck(_v,3,0,currVal_0);
        const currVal_1:any = _co.addButton;
        _ck(_v,6,0,currVal_1);
      },(null as any));
}
export function View_OptionViewComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-option-view-component',
      ([] as any[]),(null as any),(null as any),(null as any),View_OptionViewComponent_0,
      RenderType_OptionViewComponent)),i1.ɵdid(1,2867200,(null as any),0,i3.OptionViewComponent,
      [i1.ChangeDetectorRef,i4.ToastrService,i5.BsModalService],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const OptionViewComponentNgFactory:i1.ComponentFactory<i3.OptionViewComponent> = i1.ɵccf('app-option-view-component',
    i3.OptionViewComponent,View_OptionViewComponent_Host_0,{fields:'fields',addButton:'addButton',
        removeButton:'removeButton'},{onChange:'onChange',onAddClick:'onAddClick',
        onRemoveClick:'onRemoveClick'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/table-component/option-view/option-view.component.ngfactory.ts